import { useSelector } from 'react-redux';
import { REDUX_STORE_SLICES } from '../../../../../services/exports/Constants';
import { StoreInterface } from '../../../../../store/types';
import { useForm } from 'react-hook-form';
import { DeliveryAddressSchema, deliveryAddressSchema } from './schema';
import { zodResolver } from '@hookform/resolvers/zod';

const useDeliveryForm = (defaultValues: DeliveryAddressSchema) => {
  const cachedOrder = useSelector((state: StoreInterface) => state[REDUX_STORE_SLICES.ORDER].cached_order);

  return useForm<DeliveryAddressSchema>({
    defaultValues: defaultValues ?? {
      delivery_street_name: cachedOrder.delivery_street_name ?? '',
      delivery_street_number: cachedOrder.delivery_street_number ?? '',
      delivery_city: cachedOrder.delivery_city ?? '',
      delivery_zip_code: cachedOrder.delivery_zip_code ?? '',
      delivery_lat: +cachedOrder.delivery_lat,
      delivery_lng: +cachedOrder.delivery_lng,
    },
    resolver: zodResolver(deliveryAddressSchema),
  });
};

export default useDeliveryForm;
